import React, { useCallback, useState, useEffect } from "react";

interface IProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  fallback?: any;
}

const Image = (props: IProps) => {
  const {
    src,
    fallback = require("assets/images/placeholder.png"),
    ...rest
  } = props;
  const [source, setSource] = useState(src);

  useEffect(() => {
    setSource(src);
  }, [src]);

  const handleError = useCallback(() => {
    setSource(fallback);
  }, [setSource, fallback]);

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={source} onError={handleError} {...rest} />
  );
};

export default Image;
